module.exports = __webpack_public_path__ + "static/media/amaia-logo-welcome.c573c9f5.gif";